import { IdentifierDTO } from '@zazume/zzm-base';

import {
  PortalIntegration,
  PortalIntegrationTypes,
  UnitsPublicationNotAvailableStatusInPortal
} from '#/models/portalIntegration';
import { doGet, doPut } from '#lib/network/helpers';

export const portalIntegrations = {
  get: (organizationId: IdentifierDTO) => () => doGet<PortalIntegration>(`/portal-integrations/${organizationId}`),
  getPortalsIntegrationUnitsPublishedStatus: (organizationId: IdentifierDTO) => () =>
    doGet<UnitsPublicationNotAvailableStatusInPortal>(
      `/portal-integrations/${organizationId}/units/publications/status`
    ),
  createOrEdit: (organizationId: IdentifierDTO) => (body: Partial<PortalIntegration>) =>
    doPut<PortalIntegration>(`/portal-integrations/${organizationId}`, body),
  getActiveByUnit: (unitId: IdentifierDTO) => () =>
    doGet<PortalIntegrationTypes[]>(`/portal-integrations/unit/${unitId}`),
  keepZazumePublicationActive: (unitId: IdentifierDTO) => () =>
    doPut(`/portal-integrations/p2p-portals/${unitId}/zazume/keep-active`),
  updateUnitP2PPortals: (unitId: IdentifierDTO) => (operation: 'publish' | 'unpublish') =>
    doPut(`/portal-integrations/p2p-portals/${unitId}/${operation}`)
};
